import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { VisualLayer } from '@contracts/index';

export interface SessionState {
  sessionId: string;
  activeRunId: string | null;
  activeFieldId: string | null;
  currentTime: number;
  timeInterpolationEnabled: boolean;
  layers: VisualLayer[];
  selectedProbeId: string | null;
  selectedEntityId: string | null;
}

const initialState: SessionState = {
  sessionId: 'session-default-01',
  activeRunId: null,
  activeFieldId: null,
  currentTime: 0.0,
  timeInterpolationEnabled: true,
  layers: [],
  selectedProbeId: null,
  selectedEntityId: null
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setActiveRunId: (state, action: PayloadAction<string | null>) => {
      state.activeRunId = action.payload;
    },
    setActiveFieldId: (state, action: PayloadAction<string | null>) => {
      state.activeFieldId = action.payload;
    },
    setCurrentTime: (state, action: PayloadAction<number>) => {
      state.currentTime = action.payload;
    },
    setTimeInterpolationEnabled: (state, action: PayloadAction<boolean>) => {
      state.timeInterpolationEnabled = action.payload;
    },
    setLayers: (state, action: PayloadAction<VisualLayer[]>) => {
      state.layers = action.payload;
    },
    addLayer: (state, action: PayloadAction<VisualLayer>) => {
      state.layers.push(action.payload);
    },
    toggleLayerVisibility: (state, action: PayloadAction<string>) => {
      const layer = state.layers.find((l) => l.layerId === action.payload);
      if (layer) {
        layer.visible = !layer.visible;
      }
    },
    removeLayer: (state, action: PayloadAction<string>) => {
      state.layers = state.layers.filter((l) => l.layerId !== action.payload);
    },
    setSelectedProbeId: (state, action: PayloadAction<string | null>) => {
      state.selectedProbeId = action.payload;
    },
    setSelectedEntityId: (state, action: PayloadAction<string | null>) => {
      state.selectedEntityId = action.payload;
    }
  }
});

export const {
  setActiveRunId,
  setActiveFieldId,
  setCurrentTime,
  setTimeInterpolationEnabled,
  setLayers,
  addLayer,
  toggleLayerVisibility,
  removeLayer,
  setSelectedProbeId,
  setSelectedEntityId
} = sessionSlice.actions;

export default sessionSlice.reducer;
